export const Atom_LeftHand_EntityType_Variable = 'variable';
export const Atom_LeftHand_EntityType_Atom = 'atom';
export const Atom_LeftHand_EntityType_Expression = 'expression';
export const Atom_LeftHand_EntityTypes = [Atom_LeftHand_EntityType_Variable, Atom_LeftHand_EntityType_Atom, Atom_LeftHand_EntityType_Expression];
//# sourceMappingURL=types.js.map